import GATSBY_COMPILED_MDX from "/vercel/path0/content/snippets/javascript/decode-jwt-token.mdx";
import React from "react";
import {Link, graphql} from "gatsby";
import Layout from "@components/layout";
import MDXRenderer from "@components/mdx";
import Seo from "@components/seo/seo";
import TopicsBar from "@components/topics-bar";
import Giscus from "@components/giscus";
import Webmentions from "@components/webmentions";
import GitHubStar from "@components/github-star";
import SnippetHero from "../sections/snippet/snippet-hero";
import RelatedArticles from "../sections/article/article-related-articles";
import RelatedStories from "../sections/article/article-related-stories";
import RelatedTools from "../sections/article/article-related-tools";
import RelatedVideos from "../sections/article/article-related-videos";
import GitHubTypo from "@components/github-typo";
import AskFeedback from "@components/ask-feedback";
import BreadcrumbActive from "@components/breadcrumb-active";
import Authors from "@components/authors";
const SnippetPage = ({pageContext, data, children}) => {
  const {allWebMentionEntry} = data;
  const {snippet, authors, relatedArticles, relatedStories, relatedVideos, relatedTools, next, previous, category} = pageContext;
  const pageTitle = `${category.title} - ${snippet.title}`;
  const githubURL = `https://github.com/abhith/abhith.net/blob/master/content${snippet.slug.substring(0, snippet.slug.length - 1)}.mdx`;
  return React.createElement(Layout, null, React.createElement(Seo, {
    title: pageTitle,
    description: snippet.excerpt,
    isBlogPost: false,
    slug: snippet.slug,
    dateModified: snippet.dateModifiedSeoFormat,
    datePublished: snippet.datePublishedSeoFormat
  }), React.createElement("div", {
    className: "h-entry"
  }, React.createElement(SnippetHero, {
    snippet: snippet,
    authors: authors
  }), React.createElement("div", {
    className: "ar-main"
  }, React.createElement("div", {
    className: "ar-side-background"
  }), React.createElement("div", {
    className: "ar-main-container container"
  }, React.createElement("div", {
    className: "ar-duo"
  }, React.createElement("div", {
    className: "ar-lead"
  }, React.createElement("div", {
    className: "ar-breadcrumb is-hidden-mobile"
  }, React.createElement("nav", {
    className: "breadcrumb",
    "aria-label": "breadcrumbs"
  }, React.createElement("ul", null, React.createElement("li", null, React.createElement(Link, {
    to: `/`
  }, "Home")), React.createElement("li", null, React.createElement(Link, {
    to: `/snippets/`
  }, "Snippets")), React.createElement("li", null, React.createElement(Link, {
    to: `/snippets/${category.slug}/`
  }, category.title)), React.createElement("li", {
    className: "is-active"
  }, React.createElement(BreadcrumbActive, null, React.createElement("a", {
    className: "u-url",
    href: "https://www.abhith.net" + snippet.slug
  }, snippet.title))))), React.createElement("nav", {
    className: "bd-prev-next"
  }, next ? React.createElement(Link, {
    to: next.slug,
    title: next.title
  }, "←") : React.createElement("span", null, "←"), previous ? React.createElement(Link, {
    to: previous.slug,
    title: previous.title
  }, "→") : React.createElement("span", null, "→"))), React.createElement(MDXRenderer, {
    content: children
  }, React.createElement(TopicsBar, {
    topics: snippet.topics
  })), React.createElement(GitHubTypo, {
    githubURL: githubURL
  }), React.createElement(Giscus), React.createElement(Authors, {
    authors: authors
  }), React.createElement(Webmentions, allWebMentionEntry), React.createElement(AskFeedback)), React.createElement("aside", {
    className: "ar-side"
  }, React.createElement("div", {
    className: "sticky"
  }, React.createElement(GitHubStar))))))), React.createElement(RelatedArticles, {
    articles: relatedArticles
  }), React.createElement(RelatedVideos, {
    relatedVideos: relatedVideos
  }), React.createElement(RelatedStories, {
    relatedStories: relatedStories
  }), React.createElement(RelatedTools, {
    relatedServices: relatedTools
  }));
};
SnippetPage
export default function GatsbyMDXWrapper(props) {
  return React.createElement(SnippetPage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query SnippetQuery($permalink: String!) {
    allWebMentionEntry(filter: { wmTarget: { eq: $permalink } }) {
      edges {
        node {
          wmTarget
          wmSource
          wmProperty
          wmId
          type
          url
          likeOf
          author {
            url
            type
            photo
            name
          }
          content {
            text
          }
        }
      }
    }
  }
`;
